import React, { useState, useEffect } from 'react'
import { FaEnvelope, FaExternalLinkAlt, FaEnvelopeOpenText, FaGithubSquare, FaInstagramSquare, FaFacebook, FaWhatsappSquare } from 'react-icons/fa';
import { FaLinkedin, FaSquareXTwitter, FaTelegram, FaUser } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion'; 
import { useForm, ValidationError } from '@formspree/react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const HomeContact = () => {
    const [state, handleSubmit] = useForm("xgopbjpb");
    const [message, setMessage] = useState('');
    const navigate = useNavigate(); // Initialize the navigate function 
   useEffect(() => {
        if (state.succeeded) {
            // Wait 2 seconds so they can see a success message, then redirect
            const timer = setTimeout(() => {
                navigate('/'); // Redirects to the homepage
            }, 2000);

            return () => clearTimeout(timer); // Cleanup timer if component unmounts
        }
    }, [state.succeeded, navigate]);
    useEffect(() => {
        if (state.succeeded) {
            const timer = setTimeout(() => {
                navigate('/'); // Redirects to the homepage
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [state.succeeded, navigate]);

    if (state.succeeded) {
        return (
            <section className="home-contact">
                <div className="container h-75 text-center center">
                    <h2 className="h2-dark">Message sent successfully!</h2>
                    <p className="small-dark">I'll get back to you as soon as possible.</p>
                </div>
            </section>
        );
    }
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3,
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" } 
        }
    };

    return (
        <section className="home-contact">
            <div className="container h-75">
                <h2 className="h2-dark">Let’s Connect & Collaborate</h2>
                <div className="space"></div>
                
                <motion.div 
                    className="grid"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.1 }}
                >
                    <motion.div className="container" variants={itemVariants}>
                        <div className="space"></div>
                        <h3 className="card-head-primary">
                            Direct Channels <FaExternalLinkAlt/>
                        </h3>
                        <div className="wrapper">
                            <div className="flex">
                                <ul>
                                    <li>
                                        <a href="mailto:devprince101@gmail.com" className="link-dark links" >
                                            E-Mail Me {' '} <FaEnvelope className='setting'/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://wa.me/+254114344895" className="link-dark links" >
                                            Whatsapp {' '} <FaWhatsappSquare className='setting'/>
                                        </a>
                                    </li>
                                    <li>
                                        <div className="socials">
                                            <a href="https://linkedin.com/in/princemwenyemali/" className="soc-links" target='_blank' rel='noopener noreferrer'>
                                                <FaLinkedin/>
                                            </a>
                                            <a href="https://github.com/princekey23" className="soc-links" target='_blank' rel='noopener noreferrer'>
                                                <FaGithubSquare/>
                                            </a>
                                            <a href="https://www.instagram.com/congolesedesign/" className="soc-links" target='_blank' rel='noopener noreferrer'>
                                                <FaInstagramSquare/>
                                            </a>
                                            <a href="https://web.facebook.com/profile.php?id=100067352079129" className="soc-links" target='_blank' rel='noopener noreferrer'>
                                                <FaFacebook/>
                                            </a>
                                            <a href="https://x.com/princemmalikey" className="soc-links" target='_blank' rel='noopener noreferrer'>
                                                <FaSquareXTwitter/>
                                            </a>
                                        </div>
                                        <div className="w-82">
                                            <small className="small-dark text-small">
                                                Whether for a project or a quick technical question, I’m always happy to help you.
                                            </small>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div className="container" variants={itemVariants}>
                        <div className="space"></div>
                        <h3 className="card-head-primary">
                            Quick Message <FaEnvelopeOpenText/>
                        </h3>
                        <div className="wrapper shadow">
                            <form onSubmit={handleSubmit} className="flex">
                                <motion.div 
                                    className="form-group"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5 }}
                                >
                                    <div className="form-input">
                                        <label htmlFor="name" className="form-label">
                                            <FaUser/>
                                        </label>
                                        <input 
                                            type="text" 
                                            name="name" 
                                            id="name" 
                                            className="form-inputs" 
                                            placeholder="Name" 
                                            required 
                                        />
                                    </div>
                                    
                                    <div className="form-input">
                                        <label htmlFor="email" className="form-label">
                                            <FaEnvelope/>
                                        </label>
                                        <input 
                                            type="email" 
                                            name="email" 
                                            id="email" 
                                            className="form-inputs" 
                                            placeholder="Email" 
                                            required 
                                        />
                                        <ValidationError prefix="Email" field="email" errors={state.errors} />
                                    </div>
                                </motion.div>

                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.1 }}
                                    className="editor-container"
                                >
                                    <ReactQuill 
                                        theme="snow" 
                                        value={message} 
                                        onChange={setMessage} 
                                        placeholder='Write Your Message here ...'
                                    />
                                    
                                    {/* FIXED: Strips HTML tags and replaces &nbsp; with standard spaces */}
                                    <textarea 
                                        name="message" 
                                        value={message.replace(/<[^>']*>?/gm, '').replace(/&nbsp;/g, ' ')} 
                                        readOnly 
                                        style={{ display: 'none' }} 
                                    />
                                    <ValidationError prefix="Message" field="message" errors={state.errors} />
                                </motion.div>

                                <motion.button 
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                    type="submit" 
                                    className="btn light shad" 
                                    disabled={state.submitting}
                                >
                                    {state.submitting ? 'Sending...' : 'Send Message'} 
                                    {' '} <FaTelegram className='setting'/>
                                </motion.button>
                            </form>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    )
}

export default HomeContact;